import { render, staticRenderFns } from "./alarmBox.vue?vue&type=template&id=154a6118&scoped=true"
import script from "./alarmBox.vue?vue&type=script&lang=js"
export * from "./alarmBox.vue?vue&type=script&lang=js"
import style0 from "./alarmBox.vue?vue&type=style&index=0&id=154a6118&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "154a6118",
  null
  
)

export default component.exports